import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div>
      <h2>{`GIPHY SDK for iOS`}</h2>
      <h4>{`Requirements`}</h4>
      <ul>
        <li parentName="ul">{`Xcode 11.3 and later`}</li>
        <li parentName="ul">{`iOS 10 or later`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://developers.giphy.com/dashboard/?create=true"
          }}>{`A Giphy API key`}</a></li>
        <li parentName="ul">{`Xcode 11 (as of v1.1.1)`}</li>
        <li parentName="ul">{`Cocoapods or Carthage`}</li>
      </ul>
      <p>{`Get started with our iOS docs `}<a parentName="p" {...{
          "href": "https://github.com/Giphy/giphy-ios-sdk-ui-example/blob/master/Docs.md"
        }}>{`here`}</a>{`.`}</p>
      <h4>{`Github Example Repo`}</h4>
      <p>{`Give the iOS SDK `}<a parentName="p" {...{
          "href": "https://github.com/Giphy/giphy-ios-sdk-ui-example"
        }}>{`example app`}</a>{` a spin to see what it's all about.`}</p>
      <p>{`We also use Github for documentation, release notes, issue tracking, and more.`}</p>
      <ul>
        <li parentName="ul">{`View the `}<a parentName="li" {...{
            "href": "https://github.com/Giphy/giphy-ios-sdk-ui-example/blob/master/Docs.md"
          }}>{`docs`}</a>{`.`}</li>
        <li parentName="ul">{`View `}<a parentName="li" {...{
            "href": "https://github.com/Giphy/giphy-ios-sdk-ui-example/releases"
          }}>{`releases`}</a></li>
        <li parentName="ul">{`Open `}<a parentName="li" {...{
            "href": "https://github.com/Giphy/giphy-ios-sdk-ui-example/issues"
          }}>{`issues or feature requests`}</a></li>
      </ul>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      